import Vue from 'vue';
import i18n from '@/plugins/i18n';
import '@/plugins/select';

export const initWidget: (id: string, Widget: any) => void = (id, Widget) => {
  const element: HTMLElement | null = document.getElementById(`app-${id}`);
  const attributeNames = element?.getAttributeNames().filter(name => name !== 'id') || [];
  const mappedProps = attributeNames.reduce((p, attributeName) => {
    const propName = attributeName.replace('data-', '');
    const propValue = element?.getAttribute(attributeName);

    // Try to parse JSON for object props
    try {
      p[propName] = JSON.parse(propValue || '');
    } catch {
      // If parsing fails, use the raw string value
      p[propName] = propValue;
    }

    return p;
  }, {} as any);
  if (['de', 'en'].includes(mappedProps.language)) i18n.locale = mappedProps.language;
  new Vue({ i18n, render: h => h(Widget, { props: { ...mappedProps } }) }).$mount(`#app-${id}`);
};
